import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'subStr'
})

export class SubStrPipe implements PipeTransform {

    transform(value: string, args?: number): any {
        let output: string = '';
        let end: string = '';

        if (value.length > args) {
            end = ' ...';
        }

        output = value.substr(0, args) + end;
        return output;
    }
}



// WEBPACK FOOTER //
// ./src/shared/substr.pipe.ts